import { createEvent, createStore, sample } from 'effector'
import { fx } from '../../../libs'
import { DiagnosticsData } from './types'

export const diagnosticsMounted = createEvent()

export const getDiagnostics = fx<void, DiagnosticsData>({
  method: 'GET',
  url: '/diagnostics',
})

export const $diagnostics = createStore<DiagnosticsData | null>(null)
  .on(getDiagnostics.doneData, (_, r) => r.body)

export const $diagnosticsLoading = getDiagnostics.pending

sample({
  clock: diagnosticsMounted,
  fn: () => ({}),
  target: getDiagnostics,
})
